import { useIntl } from "react-intl";

import { Chip } from "@/components/Chip/Chip";

export const RequiredLabel = () => {
  const intl = useIntl();

  return (
    <div className="absolute end-4 -top-3">
      <Chip
        label={intl.formatMessage({
          defaultMessage: "Required",
          description: "required",
        })}
        color="warning-soft"
        size="xsmall"
      />
    </div>
  );
};
